import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ComplianceCustomerRequest, UpdateCustomerRequest } from '@/api';
import { ComplianceCustomersData } from '../models';

export interface ComplianceCustomersSliceState {
  data: ComplianceCustomersData;
  loading: boolean;
  error: string | null;
  lastListRequest: ComplianceCustomerRequest | null;
}

const initialState: ComplianceCustomersSliceState = {
  data: null,
  loading: false,
  error: null,
  lastListRequest: null,
};

const complianceCustomersSlice = createSlice({
  name: 'complianceCustomers',
  initialState,
  reducers: {
    setData: (state, action: PayloadAction<ComplianceCustomersData>) => ({
      ...state,
      data: action.payload,
    }),
    setLoading: (state, action: PayloadAction<boolean>) => ({
      ...state,
      loading: action.payload,
    }),
    setError: (state, action: PayloadAction<string | null>) => ({
      ...state,
      error: action.payload,
    }),
    listCustomers: (
      state,
      action: PayloadAction<ComplianceCustomerRequest>,
    ) => ({
      ...state,
      error: null,
      loading: true,
      lastListRequest: action.payload,
    }),
    updateCustomer: (state, _action: PayloadAction<UpdateCustomerRequest>) => ({
      ...state,
      error: null,
      loading: true,
    }),
  },
});

export { complianceCustomersSlice };
